<template>
  <app-layout>
    <!-- <app-stepper :scaffold="scaffold" :current="0" /> -->

    <div class="max-w-screen-xl mx-auto px-5">
      <el-breadcrumb class="my-5 w-full" separator="/">
        <el-breadcrumb-item
          :to="{ name: 'builder', params: { scaffoldId } }"
        >
          Entities
        </el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{
            name: 'entity-edit',
            params: {
              scaffoldId,
              id: entity ? entity.id : null,
              routedTab: 'field',
            },
          }"
          >{{
            entity && entity.name && entity.name.singular
              ? entity.name.singular
              : 'New Entity'
          }}</el-breadcrumb-item
        >
        <el-breadcrumb-item class="b">{{
          field && field.name && field.name.singular
            ? field.name.singular
            : 'New Field'
        }}</el-breadcrumb-item>
      </el-breadcrumb>

      <el-tabs
        v-model="tab"
        class="shadow-none"
        type="border-card"
      >
        <el-tab-pane
          v-if="field"
          name="basic"
          label="Basic"
        >
          <app-field-form-basic></app-field-form-basic>
        </el-tab-pane>
        <el-tab-pane
          v-if="propertyEnabled"
          name="property"
          label="Properties"
        >
          <app-field-form-property></app-field-form-property>
        </el-tab-pane>
        <el-tab-pane
          v-if="relationEnabled"
          name="relation"
          label="Relation"
        >
          <app-field-form-relation></app-field-form-relation>
        </el-tab-pane>
        <el-tab-pane
          v-if="validationEnabled"
          name="validation"
          label="Validations"
        >
          <app-field-validation-list></app-field-validation-list>
        </el-tab-pane>
      </el-tabs>

      <app-builder-debugger
        v-if="debugging"
        :data="field"
      ></app-builder-debugger>

      <div class="my-4">
        <el-button type="primary" @click="save()"
          >Save</el-button
        >
        <router-link
          class="el-button"
          :to="{
            name: 'entity-edit',
            params: {
              scaffoldId,
              id: entity ? entity.id : null,
              routedTab: 'field',
            },
          }"
          >Cancel</router-link
        >
      </div>
    </div>
  </app-layout>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-field-form',

  props: ['scaffoldId', 'id', 'reload'],

  created() {
    if (!this.entity) {
      this.$router.push({
        name: 'builder',
        params: { scaffoldId: this.scaffoldId },
      });
      return;
    }

    const create = !this.id;

    if (create) {
      this.$store.dispatch('builder/fieldCurrent/new');
    } else {
      const field = this.$store.getters[
        'builder/fieldCurrent/get'
      ](this.id, !!this.reload);

      if (field) {
        this.$store.dispatch(
          'builder/fieldCurrent/edit',
          field,
        );
      } else {
        this.$router.push({
          name: 'entity-edit',
          params: {
            scaffoldId: this.scaffoldId,
            id: this.entity.id,
          },
        });
      }
    }
  },

  computed: {
    ...mapGetters({
      scaffold: 'scaffold/current',
      properties: 'builder/propertyCurrent/current',
      entity: 'builder/entityCurrent/current',
      field: 'builder/fieldCurrent/current',
      debugging: 'builder/debugging',
    }),

    tab: {
      get() {
        return this.$store.state.builder.fieldCurrent.tab;
      },
      set(value) {
        this.$store.commit(
          'builder/fieldCurrent/tab',
          value,
        );
      },
    },

    propertyEnabled() {
      return this.$store.getters[
        'builder/fieldProperty/enabled'
      ](this.properties, this.entity, this.field);
    },

    relationEnabled() {
      return this.$store.getters[
        'builder/fieldRelation/enabled'
      ](this.properties, this.entity, this.field);
    },

    validationEnabled() {
      return this.$store.getters[
        'builder/fieldValidation/enabled'
      ](this.properties, this.entity, this.field);
    },
  },

  methods: {
    save() {
      const { dispatch } = this.$store;

      dispatch('builder/fieldCurrent/save')
        .then(() => {
          this.$router.push({
            name: 'entity-edit',
            params: {
              scaffoldId: this.scaffoldId,
              id: this.entity.id,
              routedTab: 'field',
            },
          });
        })
        .catch(() => {
          // ignore, it is a validation error
        });
    },
  },
};
</script>

<style></style>
